import React, { useState } from "react";
import MainBanner from "../../../Components/MainBanner";
import AskSection from "../../../Components/AskSection";
import BenefitsSection from "../../../Components/BenefitsSection";
import HelpSteps from "../../../Components/HelpSteps";
import BonusSection from "../../../Components/BonusSection";
import StudentStories from "../../../Components/StudentStories";
import ChatHelpExperts from "../../../Components/ChatHelpExperts";
import CommonForm from "../../HomePage/Form/CommonForm";
import ScrollTop from "../../../Components/Buttons/ScrollTop";
import AssignmentList from "../../../Components/AssignmentList";
import Universities from "../../../Components/Universities";
import Milestonerewards from "../../../Components/Milestonerewards";
import Page from "../../Metadata/Page";
import ComWorldWide from "../../../Components/ComWorldWide";
import ComReadMoreSection from "../../../Components/ComReadMoreSection";
import BreadCrumb from "../../../Components/BreadCrumb/BreadCrumb";

const EssayWriting = () => {
  const subCategoryId = "6586cc85d2f7eeadeea4faee";
  const categoryId = "65524e633c005ef3b51907c9";

  const [isModelOpen, setIsModelOpen] = useState(false);
  const toggle = () => {
    setIsModelOpen(!isModelOpen);
  };

  const breadCrumbData = [
    { label: "Home", path: "/" },
    { label: "Assignment Help" },
    { label: "Do My Essay Writing" },
  ];
  return (
    <>
      <Page subCategoryId={subCategoryId} categoryId={categoryId} />
      <div className="container">
        <div className="row mt-2 mb-2 m-0">
          <BreadCrumb items={breadCrumbData} />
        </div>
      </div>
      <MainBanner id={subCategoryId} setIsModelOpen={setIsModelOpen} />
      <AskSection />
      <BenefitsSection
        subCategoryId={subCategoryId}
        setIsModelOpen={setIsModelOpen}
        description="Designed to deliver quality, accuracy, and convenience for every student"
        btnText="Get Help Now"
      />
      <AssignmentList
        subCategoryId={subCategoryId}
        setIsModelOpen={setIsModelOpen}
      />
      <HelpSteps subCategoryId={subCategoryId} description="Get your Essay Writing support in 4 easy steps"/>
      <Milestonerewards 
      categoryId={categoryId}
      title="Earn Rewards with Every Assignment Milestone"
      description="Unlock exclusive rewards and benefits as you progress with each assignment"
      />
      <BonusSection
        subCategoryId={subCategoryId}
        setIsModelOpen={setIsModelOpen}
      />
      <Universities categoryId={categoryId} setIsModelOpen={setIsModelOpen} />
      <StudentStories />
      <ChatHelpExperts 
      title="Meet our Essay Writing Experts"
      description="Our professionals deliver high-quality essays with an improved writing experience"
      />
      <ComWorldWide id={subCategoryId} />
      <ComReadMoreSection id={subCategoryId} />
      {isModelOpen ? (
        <CommonForm
          isOpen={isModelOpen}
          toggle={toggle}
          typeData={{
            serviceType: "AssignmentHelp",
            type: "assignmentHelp",
            totalSteps: 1,
          }}
          subCategory={subCategoryId}
        />
      ) : (
        <></>
      )}
      <ScrollTop />
    </>
  );
};

export default EssayWriting;
